import { Component } from '@angular/core';
import { AuthenticationService } from '../../authentication/authentication/authentication.service';
import { PermissionTypeEnum } from 'src/app/common/permission-enum';

@Component({
  selector: 'app-history-productions-process',
  templateUrl: './history-productions-process.component.html',
  styleUrls: ['./history-productions-process.component.scss']
})
export class HistoryProductionsProcessComponent {
  history = 0;
  permissionType = PermissionTypeEnum;

  constructor(
      private authService: AuthenticationService
    ) {
      var permissions = authService.getPermissions();
      if (permissions) {
        for (let i = 0; i < permissions.length; i++) {
          const element = permissions[i];
          if (element.roleId == 5017) {
            this.history = 0;
            break;
          } else if (element.roleId == 5023) {
            this.history = 1;
            break;
          } else if (element.roleId == 5018) {
            this.history = 2;
            break;
          }
        }
      }
    }
}
